import { safeAxios } from '@/services/safeAxios';
import { API_ROUTES } from '@/api/apiRoutes';
import type { ResolvedAssets } from '@/types/api/assets';
import type { BlobstoreAssetRef } from 'web';

export type AssetReferenceSource = { kind: 'workflow' | 'subflow_template'; id: string };

/** Each source asset id's reference in the destination (`null` when it gets none), and signed urls for the new ids. */
export interface CopiedAssetResponse {
  copied: boolean;
  copiedRefs: Record<string, BlobstoreAssetRef | null>;
  resolvedAssets: ResolvedAssets;
}

export const copyAssetReferences = async (request: {
  source: AssetReferenceSource;
  destinationWorkflowId: string;
  assetIds: string[];
}): Promise<CopiedAssetResponse> => {
  const res = await safeAxios.post<CopiedAssetResponse>(API_ROUTES.assets.copyReferences(), request, {});
  return res.data;
};
